import { atom } from "jotai";

import { CreateCustomerUserInput } from "../../../hooks/__generated__/useCreateNewCustomerUserMutation.graphql";
import { CodeVerificationType, VerifyCodeStepState } from "../../../types";
import {
  VerificationModalStepStateAtom,
  VerificationModalTrackEventAtom,
} from "../../stores";

export const ProceedToVerifyCodeStepAtom = atom(
  null,
  (
    get,
    set,
    {
      email,
      phone,
      type = "NewAccount",
      formDataToSubmit,
    }: {
      email: string | null;
      phone: string | null;
      type?: CodeVerificationType;
      formDataToSubmit?: CreateCustomerUserInput;
    }
  ) => {
    const track = get(VerificationModalTrackEventAtom);
    const nextStep: VerifyCodeStepState = {
      step: "VerifyCode",
      email,
      phone,
      verificationType: type,
      backStep: "Initial",
      formDataToSubmit,
    };
    set(VerificationModalStepStateAtom, nextStep);
    track?.("AuthModal.VerifyCodeStep", nextStep);
  }
);
